<ng-template #playScratchModal let-modal>
    <div class="d-flex-center">
        <div [style]="'width: 100%; border-radius: 15px; background-color: '+selectedScratch.colorTheme+'; '">
            <div class="d-flex-between p-20">
                <div class="font-h5 text-white text-center">{{selectedScratch.name}}</div>
            </div> 
            <div class="d-flex-center">
                <img [src]="selectedScratch.logoUrl" class="scratch-img" style="width: 250px;">
            </div>
            <div class="m-t-20 text-center">
                <div class="font-h5 text-white">RASPA Y GANA</div>
                <div class="font-c1 text-white">Raspa a continuación para probar suerte</div>
            </div> 
            <ng-container *ngIf="isCommunityMember && (selectedScratch.communityId > 0  || selectedScratch.communityId == null)">
                <ng-container *ngIf="hasPlayed"> 
                    <div class="form-control-feedback text-center m-t-20">
                        <img src="assets/images/hasplayed.png" width="320">
                    </div>
                    <div *ngIf="timeRemaining && hasMoreAttemps" class="text-white font-c1 text-center m-t-10 m-l-10 m-r-10">
                        <div>Tiempo restante para volver a jugar: <br> {{ timeRemaining }}</div>
                    </div>
                    <div *ngIf="!timeRemaining && !hasMoreAttemps" class="text-white font-c1 text-center m-t-10">
                        <div>No tenés más intentos</div>
                    </div>
                    <div class="form-control-feedback text-center m-t-10 m-b-20">
                        <a class="text-white font-c1" (click)="onClose()" style="text-decoration: underline;">
                            Cerrar
                        </a>
                    </div>
                </ng-container> 
                <ng-container *ngIf="customerGiveaways && !hasPlayed" class="m-t-20">
                    <div class="d-flex-center">
                        <div class="m-b-20" style="width: 80%;">
                            <app-scratch-box [country]="country" [selectedScratch]="selectedScratch" [transactionPackageId]="transactionPackageId" [coupon]="coupon" [isWinner]="isWinner" [customerId]="customerGiveaways.id"
                            [uniqueLinkCode]="uniqueLinkCode" (claimGiveaway)="onClaimGiveaway()" (onCloseEvent)="onClose()"></app-scratch-box>
                        </div>
                    </div> 
                </ng-container>
            </ng-container> 
            <ng-container *ngIf="!isCommunityMember">
                <div style="background-color: #fff; padding: 10px; border-radius: 20px; margin: 20px;" (click)="onGoCommunity()">
                    <div class="font-18 font-bold text-center">No formas parte de la comunidad</div>
                    <div class="font-14 text-center">Hace click en "Ir a la comunidad" para solicitar ser parte</div>
                    <div class="form-control-feedback text-center m-t-20">
                        <img src="assets/images/nocommunity.png" width="320">
                    </div>
                    <div class="form-control-feedback text-center m-t-10">
                        <a class="font-c1" style="text-decoration: underline;">
                            Ir a la comunidad
                        </a>
                    </div> 
                </div> 
            </ng-container>
        </div> 
    </div>  
</ng-template>

<ng-container *ngIf="assignedSuccess">
    <app-assigned-givi (close)="onCloseSucess()"></app-assigned-givi>
</ng-container>